<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">排班名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡更班组：</span>
        </div>
        <el-select v-model="formData.patrolTeamCode" size="small" style="width: 280px">
          <el-option v-for="item in patrolTeamList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡更路线：</span>
        </div>
        <el-select v-model="formData.patrolRouteCode" size="small" style="width: 280px">
          <el-option v-for="item in patrolRouteList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">排班周期：</span>
        </div>
        <el-date-picker v-model="rosterCycleDate" size="small" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">排班类型：</span>
        </div>
        <el-radio-group v-model="formData.timeType" size="small">
          <el-radio-button :label="0" >按天</el-radio-button>
          <el-radio-button :label="1" >按周</el-radio-button>
        </el-radio-group>
      </div>

      <div class="form-line" v-if="formData.timeType === 1">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">周期天数：</span>
        </div>
        <el-checkbox-group v-model="formData.dateIndexList" size="small">
          <el-checkbox-button v-for="(day, dayIndex) in weekDay" :label="(dayIndex + 1).toString()" :key="dayIndex">{{day}}</el-checkbox-button>
        </el-checkbox-group>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡更开始时间：</span>
        </div>
        <el-time-picker v-model="formData.rosterStartTime" size="small" placeholder="巡更开始时间" value-format="HH:mm:ss" style="width: 280px"></el-time-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡更结束时间：</span>
        </div>
        <el-time-picker v-model="formData.rosterEndTime" size="small" placeholder="巡更结束时间" value-format="HH:mm:ss" style="width: 280px"></el-time-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">巡更误差时间：</span>
        </div>
        <el-input v-model="formData.discrepancyTime" size="small" style="width: 280px" >
          <template slot="append">分钟</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否按顺序：</span>
        </div>
        <el-switch
          v-model="formData.inOrder"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/KeepWatch'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'workforce-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧巡更',
          name: 'team-manage'
        }, {
          value: '排班管理'
        }],
        mainTitle: '修改排班',
        subheading: '',

        buildingList: [],
        floorList: [],

        patrolTeamList: [],
        patrolRouteList: [],

        rosterCycleDate: '',
        rosterTime: '',

        pickerOptions: {
          shortcuts: [{
            text: '未来一年',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '未来三年',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 3);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '未来十年',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 10);
              picker.$emit('pick', [start, end]);
            }
          }]
        },

        weekDay: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],

        formData: {
          name: '',
          patrolTeamCode: '',
          patrolTeamName: '',
          patrolRouteCode: '',
          patrolRouteName: '',
          rosterCycleStart: '',
          rosterCycleEnd: '',
          rosterStartTime: '',
          rosterEndTime: '',
          discrepancyTime: '',
          inOrder: false,
          timeType: 0,
          dateIndexList: []
        },

      }
    },
    created () {
      this.getPatrolRouteList()
      this.getPatrolTeamList()
      this.getPatrolRosterByCode(this.$route.params.id)
    },
    methods: {
      // 查询排班信息
      getPatrolRosterByCode (code) {
        this.$axios.get(`${api.getPatrolRosterByCode}/${code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              this.formData = resData
              this.rosterCycleDate = [resData.rosterCycleStart, resData.rosterCycleEnd]
              this.rosterTime = [resData.rosterStartTime, resData.rosterEndTime]
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 获取巡更点列表
      getPatrolRouteList () {
        this.$axios.post(api.getPatrolRouteList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.patrolRouteList = res.data.data
            }
          })
          .catch(errorHandler('获取巡更点列表失败'))
      },
      // 获取班组列表
      getPatrolTeamList () {
        this.$axios.post(api.getPatrolTeamList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.patrolTeamList = res.data.data
            }
          })
          .catch(errorHandler('获取巡更点列表失败'))
      },

      toManagePage () {
        this.$router.push({
          name: 'workforce-manage'
        })
      },

      confirm () {
        if (!this.formData.name) {
          nError('请输入排班名称')
          return false
        }
        if (!this.formData.patrolTeamCode) {
          nError('请选择巡更班组')
          return false
        }
        if (!this.formData.patrolRouteCode) {
          nError('请选择巡更路线')
          return false
        }
        if (!this.rosterCycleDate) {
          nError('请选择排班周期')
          return false
        }
        if (!this.formData.rosterStartTime && !this.formData.rosterEndTime) {
          nError('请选择巡更时间')
          return false
        }
        this.patrolTeamList.map(v => {
          if (v.code === this.formData.patrolTeamCode) {
            this.formData.patrolTeamName = v.name
          }
        })
        this.patrolRouteList.map(v => {
          if (v.code === this.formData.patrolRouteCode) {
            this.formData.patrolRouteName = v.name
          }
        })
        this.formData.rosterCycleStart = this.rosterCycleDate[0]
        this.formData.rosterCycleEnd = this.rosterCycleDate[1]
        this.$axios.post(api.updatePatrolRoster, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/KeepWatch/WorkforceManage/WorkforceModify.vue